import { useEffect, useState } from "react";
import { db } from "./firebaseConfig";
import { collection, getDocs, addDoc, doc, serverTimestamp, deleteDoc } from "firebase/firestore";
import "./index.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

export default function Notifications() {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [selected, setSelected] = useState(null);
  const [preview, setPreview] = useState(false);
  const [sending, setSending] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchNotifications = async () => {
      const snapshot = await getDocs(collection(db, "notificacoes"));
      const list = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setNotifications(list);
    };
    fetchNotifications();
  }, []);

  const openPanel = (n = null) => {
    if (n) {
      setSelected(n);
      setTitle(n.title || "");
      setMessage(n.text || "");
      setPreview(true);
    } else {
      setSelected({ id: "temp", title: "", text: "" });
      setTitle("");
      setMessage("");
      setPreview(false);
    }
  };

  const handlePreview = () => {
    if (!title || !message) {
      alert("Título e mensagem são obrigatórios");
      return;
    }
    setPreview(true);
  };

  const handleSendDirectFCM = async () => {
    if (sending) return;
    setSending(true);

    try {
      const notifRef = await addDoc(collection(db, "notificacoes"), {
        title,
        text: message,
        created_time: serverTimestamp(),
      });

      const usersSnapshot = await getDocs(collection(db, "utilizadores"));
      await addDoc(collection(db, "not_seen_by"), {
        notificacao: notifRef,
        users: usersSnapshot.docs.map(d => doc(db, d.ref.path)),
      });

      const userRefsList = usersSnapshot.docs.map(d => d.ref.path); 
      await addDoc(collection(db, "ff_push_notifications"), {
        notification_title: title,
        notification_text: message,
        num_sent: 0,
        target_audience: "flutterflow",
        user_refs: userRefsList,
      });

      alert("Notificação guardada e será enviada automaticamente.");

      setTitle("");
      setMessage("");
      setPreview(false);
      setSelected(null);

      const snapshot = await getDocs(collection(db, "notificacoes"));
      const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNotifications(list);

    } catch (err) {
      alert("Erro ao criar a notificação");
    }

    setSending(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Tem certeza de que deseja excluir esta notificação da app?")) return;
    await deleteDoc(doc(db, "notificacoes", id));
    setNotifications(notifications.filter((n) => n.id !== id));
  };

  const filteredNotifications = notifications.filter((n) =>
    n.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="table-container">
      <div className="filters">
        <input
          type="text"
          placeholder="Procurar por título"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="input"
        />
        <button className="btn btn-add" onClick={() => openPanel()}>
          Nova Notification
        </button>
      </div>

      <div>
        {filteredNotifications.length === 0 ? (
          <p style={{ textAlign: "center", color: "#292f2c" }}>Sem notificações</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Título</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredNotifications.map((n) => (
                <tr key={n.id}>
                  <td>{n.title}</td>
                  <td>
                    <button className="btn btn-add" onClick={() => openPanel(n)}>Abrir</button>
                    <button className="btn btn-delete" onClick={() => handleDelete(n.id)}>Apagar</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {selected && (
        <div className="drawer">
          <div className="drawer-content">
            {!preview ? (
              <>
                <label>Título:</label>
                <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
                <br /><br />
                <label>Mensagem:</label>
                <input type="text" value={message} onChange={(e) => setMessage(e.target.value)} />
              </>
            ) : (
              <>
                <h3>Pré-vsualização:</h3><br></br><br></br>
                <p><strong>{title}</strong></p>
                <p>{message}</p>
              </>
            )}
          </div>

          <div className="drawer-footer">
            {!preview ? (
              <>
                <button className="btn btn-add" onClick={handlePreview}>Seguinte</button>
                <button className="btn btn-cancel" onClick={() => setSelected(null)}>Cancelar</button>
                <button className="btn btn-cancel" onClick={() => setSelected(null)}>Fechar</button>
              </>
            ) : (
              <>
                {selected.id === "temp" && !sending && (
                  <button className="btn btn-add" onClick={handleSendDirectFCM}>Enviar Agora</button>
                )}
                {sending && <p>A processar notificação...</p>}
                {selected.id === "temp" && (
                  <button className="btn btn-cancel" onClick={() => setPreview(false)}>Voltar</button>
                )}
                <button className="btn btn-cancel" onClick={() => setSelected(null)}>Fechar</button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
